import React from 'react'
import { connect } from 'react-redux'
import { lower } from 'change-case'
import { Field, getFormValues } from 'redux-form'
import { Fade } from '@material-ui/core'

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { StdCard } from 'components'

import { ProcurementBody } from 'routes/ProcurementSystem/styled'
import { Container } from './styled'

const RequestInfo = props => {

  return (
    <Fade in={true} timeout={1000}>
      <ProcurementBody>
        <StdCard title="Request Information">
          <Container>
            <div className="rowFields">
              <Field
                name="title"
                label="Title"
                type={type.text}
                component={FieldInput}
                editable={false}
                tooltip
              />
              <Field
                name="requesterName"
                label="Requester"
                type={type.text}
                component={FieldInput}
                editable={false}
              />
            </div>
            <div className="rowFields">
              <Field
                name='companyName'
                label='Company'
                type={type.text}
                component={FieldInput}
                editable={false}
              />
              <Field
                name='projectName'
                label='Project Name'
                type={type.text}
                component={FieldInput}
                editable={false}
              />
            </div>
          </Container>
        </StdCard>
      </ProcurementBody>
    </Fade>
  )
}

const mapStateToProps = state => {
  return {
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(RequestInfo)
